import { render, staticRenderFns } from "./jiahuo.vue?vue&type=template&id=775a28aa&scoped=true&"
import script from "./jiahuo.vue?vue&type=script&lang=js&"
export * from "./jiahuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a28aa",
  null
  
)

export default component.exports